<template>
  <div class="gj-pt10 gj-pl16 gj-pr16 bgf gj-boxbor" style="height: 100%">
    <app-top-tabs :tabs="claimTab" :tab-width-auto="true">
      <template #inventoryClaim>
        <app-inventory-claim style="padding: 10px 0;"></app-inventory-claim>
      </template>
      <template #returnClaim>
        <app-return-claim style="padding: 10px 0;"></app-return-claim>
      </template>
      <template #shipmentClaim>
        <app-shipment-claim style="padding: 10px 0;"></app-shipment-claim>
      </template>
    </app-top-tabs>
  </div>
</template>

<script>
  import AppInventoryClaim from "./components/inventory-claim/inventory-claim";
  import AppReturnClaim from "./components/return-claim/claim-return-goods";
  import AppShipmentClaim from "./components/shipment-claim/shipment-claim";

  export default {
    name: "claim1",
    components: {
      AppInventoryClaim,
      AppReturnClaim,
      AppShipmentClaim
    },
    data() {
      return {
        claimTab: [
          {id: 'inventoryClaim', text: '库存索赔'},
          {id: 'returnClaim', text: '退货索赔'},
          {id: 'shipmentClaim', text: '货件索赔'},
        ]
      }
    },
  }
</script>

<style scoped>
.bgf {
  background: #fff;
}
</style>
